export {default} from './external-link.vue'
